  class SnowFallEverywhere{
    constructor(){
      this.flake = document.createElement("div");
      this.flake.className = "hc-snowflake";
      this.screen_width = window.innerWidth;
      this.screen_height = window.innerHeight;
      this.particle;
      this.camera;
      this.scene;
      this.renderer;
      this.particles = [];
      this.particleImage = new Image();
      this.particleImage.src = "https://cdn.shopify.com/s/files/1/1509/0040/files/snowflake.png?v=1600941339";
    }

    let_it_snow(){
      document.body.appendChild(this.flake);
      this.camera = new THREE.PerspectiveCamera(75, this.screen_width / this.screen_height, 1, 1e4);
      this.camera.position.z = 1e3;
      this.scene = new THREE.Scene();
      this.scene.add(this.camera);
      this.renderer = new THREE.CanvasRenderer();
      this.renderer.setSize(this.screen_width, this.screen_height);

      var material = new THREE.ParticleBasicMaterial({ map: new THREE.Texture(this.particleImage) });

      for (var n = 0; n < 500; n++){
        this.particle = new Particle3D(material);
        this.particle.position.x = 2000 * Math.random() - 1000;
        this.particle.position.y = 2000 * Math.random() - 1000;
        this.particle.position.z = 2000 * Math.random() - 1000;
        this.particle.scale.x = this.particle.scale.y = 1;
        this.scene.add(this.particle);
        this.particles.push(this.particle);
      }

      this.flake.appendChild(this.renderer.domElement);
      setInterval(this.loop.bind(this), 2000 / 60);
    }

    loop(){
      for (var i = 0; i < this.particles.length; i++){
        var particle = this.particles[i];
        particle.updatePhysics();

        if (particle.position.y < -1000){ particle.position.y += 2000; }
        if (particle.position.x > 1000){ particle.position.x -= 2000; }
        else if (particle.position.x < -1000){ particle.position.x += 2000; }
        if (particle.position.z > 1000){ particle.position.z -= 2000; }
        else if (particle.position.z < -1000){ particle.position.z += 2000; }
      }

      this.camera.position.x += 0.05 * (-this.camera.position.x);
      this.camera.position.y += 0.05 * (-this.camera.position.y);
      this.camera.lookAt(this.scene.position);
      this.renderer.render(this.scene, this.camera);
    }
  }

  document.addEventListener("DOMContentLoaded", function(){
    if (!document.querySelector(".hc-snowflake")){
      console.log("let it snow");
      const SnowFall = new SnowFallEverywhere();
      SnowFall.let_it_snow();
    }
  });